import React, { useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import { Scaffold } from 'layouts';
import { FormPageHeader } from 'components/Shared';
import { SetupCreationForm } from 'components/Pages/VehicleSetups';
import * as S from './styles';

export const VehicleSetupCreationPage: React.FC = () => {
  const navigate = useNavigate();

  const onCreate = useCallback((): void => {
    navigate('/configuracoes/setups-veiculos');
  }, [navigate]);

  return (
    <Scaffold>
      <S.PageContainer>
        <S.MainPanel>
          <FormPageHeader
            title="Novo setup de veículo"
            icon={<S.TruckIcon />}
            actions={
              <S.LinkButton size="small" to="/configuracoes/setups-veiculos">
                <S.ArrowLeftIcon /> Voltar
              </S.LinkButton>
            }
          />
          <SetupCreationForm onCreate={onCreate} />
        </S.MainPanel>
      </S.PageContainer>
    </Scaffold>
  );
};
